<template>
  <nav :class="'nav_container' + (showCompactName ? ' compact_name' : '')" :style="headerStyle">
    <div class="nav_left">
      <top-menu-toggle />
      <div class="nav_logo_container">
        <template v-if="appConfig.isAvglDomain">
          <div class="nav_logo_dropdown">
            <a class="nav_logo nav_logo_other boomtv" :href="routeBoomTV()">
              <i class="sp-ic-md-logo-v2" />
              <!-- <div class="nav_logo_title">Community esports made easy</div> -->
            </a>
            <a class="nav_logo nav_logo_on avgl" :href="routeLanding()">
              <i class="sp-ic-md-avgl_logo" style="width: 126px; height: 40px;" />
              <!-- <div class="nav_logo_title">The home of academic esports</div> -->
            </a>
            <i v-click-outside="clickOutsideLogoMenu" class="sp-ic-sm-arrow-bottom nav_logo_arrow" @click="toggleLogoMenu()" />
          </div>
        </template>
        <template v-else-if="appConfig.isQueueUpDomain">
          <div class="nav_logo_dropdown">
            <div class="nav_logo_avgl_temp" />
            <a class="nav_logo nav_logo_other avgl" :href="routeAvgl()">
              <i class="sp-ic-md-avgl_logo" />
              <!-- <div class="nav_logo_title">The home of academic esports</div> -->
            </a>
            <a class="nav_logo nav_logo_other boomtv" :href="routeBoomTV()">
              <i class="sp-ic-md-logo-v2" />
              <!-- <div class="nav_logo_title">Community esports made easy</div> -->
            </a>
            <i v-click-outside="clickOutsideLogoMenu" class="sp-ic-sm-arrow-bottom nav_logo_arrow" @click="toggleLogoMenu()" />
          </div>
        </template>
        <template v-else>
          <div class="nav_logo_dropdown">
            <a class="nav_logo nav_logo_other avgl" :href="routeAvgl()">
              <i class="sp-ic-md-avgl_logo" />
              <!-- <div class="nav_logo_title">The home of academic esports</div> -->
            </a>
            <a class="nav_logo nav_logo_on boomtv" :href="routeLanding()">
              <i class="sp-ic-md-logo-v2" />
              <!-- <div class="nav_logo_title">Community esports made easy</div> -->
            </a>
            <i v-click-outside="clickOutsideLogoMenu" class="sp-ic-sm-arrow-bottom nav_logo_arrow" @click="toggleLogoMenu()" />
          </div>
        </template>
      </div>
    </div>
    <div class="nav_right">
      <search-bar />
      <div class="nav_links">
        <div v-if="appConfig.auth_check" class="dropdown_header" :style="!checkMobileDevice() ? 'display: flex; align-items: center; height: 60px' : ''" @mouseover="showProfileDropdown()" @mouseleave="hideProfileDropdown()">
          <a v-click-outside="hideProfileDropdown" class="nav_link" @click="handleClickProfileDropdown()">
            <div class="link_image" style="margin-right: 5px; width: 20px">
              <i v-if="displayAvatar.type === 'icon' && displayAvatar.data === 'boom_icon_orange'" :class="'sp-ic-sm-' + displayAvatar.data" style="width: 16px; height: 11px;" />
              <i v-if="displayAvatar.type === 'icon' && displayAvatar.data !== 'boom_icon_orange'" :class="'sp-ic-sm-' + displayAvatar.data" style="width: 20px; height: 20px;" />
              <img v-if="displayAvatar.type === 'image'" id="header_avatar_user_mobile" class="lazyload" :data-src="displayAvatar.data" style="height: 20px; border-radius: 50%">
            </div>
            <div class="link_name" style="display: flex; align-items: center">
              <i v-if="displayAvatar.type === 'icon' && displayAvatar.data === 'boom_icon_orange'" :class="'sp-ic-sm-' + displayAvatar.data" style="width: 16px; height: 11px;" />
              <i v-if="displayAvatar.type === 'icon' && displayAvatar.data !== 'boom_icon_orange'" :class="'sp-ic-sm-' + displayAvatar.data" style="width: 20px; height: 20px;" />
              <img v-if="displayAvatar.type === 'image'" id="header_avatar_user" class="lazyload" :data-src="displayAvatar.data">
              <span id="header_displayname" style="line-height: 19px">{{ userData.email_display_name }}</span>
              <div v-if="userData.missing_order && userData.missing_order.length > 0" class="missing_order_warning"><span>!</span></div>
            </div>
            <div class="link_arrow">
              <i class="sp-ic-sm-arrow-bottom" />
            </div>
          </a>
          <div v-if="!checkMobileDevice()" class="dropdown-content dropdown-content-header">
            <div v-if="!appConfig.isAvglDomain" class="dropdown_link hypernet_currency_2">
              <div>
                <i class="currency_coin_sc sp-ic-sm-BoomBucs-icon" />
              </div>
              <div class="currency_text_sc">
                <span id="store-coins">{{ number_format(userData.game_credit) }}</span>
              </div>
              <a title="Buy Boom Bucs" class="bc_add_2 show_checkout_modal_boom_bucs" href="javascript:void(0)">
                <div class="add_icon" />
              </a>
            </div>
            <a class="dropdown_link" :href="routeMyProfile()">
              My Profile
              <div v-if="userData.missing_order && userData.missing_order.length > 0" class="missing_order_warning"><span>!</span></div>
            </a>
            <a class="dropdown_link" :href="routePubgCreateEvent('create')">My Admin</a>
            <a
              v-if="userData.has_community"
              class="dropdown_link"
              :href="routeProfile(userData.name)"
            >
              My Community
            </a>
            <template v-if="!appConfig.isAvglDomain">
              <a class="dropdown_link" :href="routeSubTourneys()">Sub Tourneys</a>
              <!--            <a class="dropdown_link" :href="routeSubscriptions()">Montage Subs</a>-->
            </template>
            <!--<a v-if="userHubData.my_hub_name" class="dropdown_link" :href="userHubData.my_hub_url">My Hub</a>-->
            <a class="dropdown_link sign_out" @click="logout()">Sign Out</a>
            <a class="dropdown_link" style="display: flex" href="#">
              <span class="settings_switch_status">Light</span>
              <switch-button
                v-model="themeStatus"
                @toggle="handleChangeTheme"
              />
              <span class="settings_switch_status">Dark</span>
            </a>
          </div>
        </div>
        <template v-else>
          <template v-if="appConfig.isAvglDomain">
            <a class="nav_link user show" :style="!checkMobileDevice() ? 'margin: 0 15px' : ''" @click="showLogin()">
              <div class="link_image">
                <i class="fa fa-user" style="color: #efefef" />
              </div>
              <div class="link_name">Sign In</div>
            </a>
            <a class="nav_link user show" style="margin-left: 15px" @click="showAvglRegister()">
              <div class="link_image">
                <i class="fa fa-user-plus" style="color: #efefef" />
              </div>
              <div class="link_name">Register</div>
            </a>
          </template>
          <a v-else class="nav_link user show" @click="showLogin()">
            <div class="link_image">
              <i class="sp-ic-sm-lock" style="width: 16px; height: 16px" />
            </div>
            <div class="link_name">Sign In</div>
          </a>
        </template>
        <a class="nav_link user show" onclick="" style="margin-left: 0px; color: white">
          <div v-click-outside="clickOutsideNotificationBoard" class="notifications-area" style="margin: 0 10px; position: relative;" @click="toggleNotificationBoard()">
            <i id="notifcation_bell" :class="getNotificationIconClass()" style="width: 24px; height: 24px; vertical-align: middle" @mouseover="handleMouseOverNotificationIcon()" @mouseleave="handleMouseOutNotificationIcon()" />
            <span
              id="number_of_notification"
              :class="{hide: countNotViewedNotification <= 0 || isShowingNotificationBoard}"
              style="height: 15px;width: 15px;background-color: red;border-radius: 50%;display: inline-block;position: absolute;color: #ffffff;right: 0px;top: -2px;text-align: center;font-weight: bold;font-size: 9px;"
            >{{ countNotViewedNotification }}</span>
            <notification-board />
          </div>
        </a>
        <a class="nav_link nav_link_drop" style="margin-left: 1px; color: white" @click="redirectToDropsPage()">
          <div class="link_name" style="height: 23px; left: 0; position: relative;">
            <i class="sp-ic-sm-drops-crown" style="width: 23px" />
            <span id="drops_notif_highlight" :class="{hide: !isShowDropsHighlight}" style="height: 13px; width: 13px; background-color: red; border-radius: 50%; position: absolute; right: 1px; top: -2px; border: 1px solid grey" />
          </div>
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import { component } from '../../mixins/component';
import { ProviderMixin } from '../../mixins/provider';
import { ConfigMixin } from '../../mixins/config';
import { LandingAPI } from '../../api/landing';
import { UserMixin } from '../../mixins/user';
import { helper } from '../../mixins/helper';
import {
  EventBus,
  SHOW_MODAL_LOGIN,
  SHOW_MODAL_ONBOARDING_INITIAL,
  SHOW_MODAL_SELECT_MANAGE_HUB,
  HANDLE_CHANGE_THEME,
  TOGGLE_TOP_MENU_LOGO,
  TOGGLE_DROPDOWN_PROFILE_TOP_HEADER,
  TOGGLE_SEARCH_BAR,
  HANDLE_CHANGE_THEME_SETTING,
} from '../../event-bus';
import { UserAPI } from '../../api/user';
import { mapActions, mapGetters } from 'vuex';
import NotificationBoard from './NotificationBoard';
import ClickOutside from 'vue-click-outside';
import { NotificationAPI } from '../../api/notfication';
import SwitchButton from '../profile/profile-menu/settings_tab/swtich-button';

export default {
  components: { NotificationBoard, SwitchButton },
  directives: {
    ClickOutside,
  },
  mixins: [component, ConfigMixin, LandingAPI, UserMixin, helper, UserAPI, NotificationAPI, ProviderMixin],
  data() {
    return {
      faqStatuses: {
        extension: false,
        raffle: false,
        sub_tournament: false,
        tournament: false,
      },
      displayAvatar: {
        type: '',
        data: '',
      },
      headerStyle: '',
      previousTop: 0,
      themeStatus: 1,
      numberNotiGameDescription: 0,
      showLogoDropdownMenu: false,
      showCompactName: false,
    };
  },
  computed: {
    ...mapGetters('notifications', ['countNotViewedNotification', 'isShowingNotificationBoard', 'isHoveringNotificationBoard']),
    ...mapGetters('rewards', ['isShowDropsHighlight']),
  },
  watch: {
    isAuth: function(newVal, oldVal) {
      if (newVal) {
        this.displayAvatar = this.getUserAvatar();
      }
    },
  },
  async created() {
    // this.getFAQStatuses();
    if (this.isAuth) {
      this.displayAvatar = this.getUserAvatar();
    }
    this.initScroll();
    this.initDeviceChangeThemeEventListener();
    this.checkShowDropsHighlight();
    this.setSwitchTheme();
    // GAME-9606 This extension to the right should not be happening, and the search bar should stay in its position once fully extended left.
    // EventBus.$on(TOGGLE_SEARCH_BAR, (searchView) => {
    //   if (searchView === 'expand') {
    //     this.showCompactName = true;
    //   } else {
    //     this.showCompactName = false;
    //   }
    // });
    // at the moment, header does not need information "isQbuddyRegistered", so next lines are needed to be hide
    // const isQbuddyRegistered = await this.isProviderAccountRegistered();
    // this.updateUserExtraData({ isQbuddyRegistered });
  },
  beforeDestroy() {
    EventBus.$off(TOGGLE_SEARCH_BAR);
  },
  methods: {
    ...mapActions({
      setShowDropsHighlight: 'rewards/setShowDropsHighlight',
      // updateUserExtraData: 'user/updateExtraData',
    }),
    async getFAQStatuses() {
      this.faqStatuses = await this.getFAQStatusesAPI();
    },
    setSwitchTheme() {
      const theme = localStorage.getItem('theme');
      if (theme === 'light') {
        this.themeStatus = 1;
      } else {
        this.themeStatus = 0;
      }
    },
    async handleChangeTheme(status){
      const dataUpdate = {};
      dataUpdate['field'] = 'theme';
      dataUpdate['status'] = status;
      console.log(status);
      EventBus.$emit(HANDLE_CHANGE_THEME, status);
      if (status === 0) { // dark theme
        localStorage.setItem('theme', 'dark');
        document.documentElement.setAttribute('data-theme', 'dark');
        const dataUpdate = {};
        dataUpdate['theme'] = 'dark';
        if (this.targetUserData && this.targetUserData.theme){
          this.targetUserData.theme = 'dark';
        }
        this.$store.dispatch('user/updateUser', dataUpdate);
        await this.updateBackgroundFollowByTheme('dark');
      } else { // light theme
        localStorage.setItem('theme', 'light');
        document.documentElement.setAttribute('data-theme', 'light');
        const dataUpdate = {};
        dataUpdate['theme'] = 'light';
        if (this.targetUserData && this.targetUserData.theme){
          this.targetUserData.theme = 'light';
        }
        this.$store.dispatch('user/updateUser', dataUpdate);
        await this.updateBackgroundFollowByTheme('light');
      }
    },
    updateBackgroundFollowByTheme(theme){
      const prefixLightTheme = '_light_theme';
      if (!this.targetUserData || !this.targetUserData.background_img){
        return;
      }
      if (theme === 'dark'){
        if (this.targetUserData.background_img.includes(prefixLightTheme)){
          const arr = this.targetUserData.background_img.split(prefixLightTheme);
          this.targetUserData.background_img = arr.join('');
        }
      } else if (theme === 'light'){
        if (!this.targetUserData.background_img.includes(prefixLightTheme)){
          const arr = this.targetUserData.background_img.split('.png');
          this.targetUserData.background_img = arr.join(prefixLightTheme + '.png');
        }
      }
    },
    getUserAvatar() {
      if (this.userData.type === this.USER_TYPES.MIXER) {
        return {
          type: 'icon',
          data: 'mixer_icon_v2',
        };
      }
      if (this.userData.type === this.USER_TYPES.YOUTUBE) {
        return {
          type: 'icon',
          data: 'youtube_icon_v2',
        };
      }
      if (this.userData.type === this.USER_TYPES.TWITTER) {
        return {
          type: 'icon',
          data: 'if_twitter_317720',
        };
      }
      if (this.userData.type === this.USER_TYPES.GOOGLE) {
        return {
          type: 'image',
          data: this.contentCloudFront('/assets/v1/google_icon.png'),
        };
      }
      if (this.userData.type === this.USER_TYPES.EMAIL) {
        if (this.userData.avatar) {
          return {
            type: 'image',
            data: this.userData.avatar,
          };
        }
        if (this.userData.hub_avatar) {
          return {
            type: 'image',
            data: this.userData.hub_avatar,
          };
        }
        if (this.appConfig.isAvglDomain) {
          return {
            type: 'icon',
            data: 'avgl_default_profile',
          };
        } else {
          return {
            type: 'icon',
            data: 'boom_icon_orange',
          };
        }
      }
      return {
        type: 'icon',
        data: 'twitch_icon',
      };
    },
    showAvglRegister() {
      EventBus.$emit(SHOW_MODAL_ONBOARDING_INITIAL);
    },
    showLogin() {
      EventBus.$emit(SHOW_MODAL_LOGIN, '', '', true);
    },
    async logout() {
      const res = await this.logoutAPI();
      if (res.status === 0) {
        window.location.replace(res.data);
      }
    },
    getNotificationIconClass() {
      if (this.countNotViewedNotification <= 0 || this.isShowingNotificationBoard) {
        return 'sp-ic-sm-onclick_notification_bell';
      } else {
        if (this.appConfig.isAvglDomain) {
          return 'sp-ic-sm-notification_red_bell';
        } else {
          return 'sp-ic-sm-notification_bell';
        }
      }
    },
    handleMouseOverNotificationIcon() {
      if (this.countNotViewedNotification > 0 && !this.isShowingNotificationBoard) {
        return;
      }
      let className = 'sp-ic-sm-onclick_notification_bell';
      if (this.appConfig.isAvglDomain) {
        className = 'sp-ic-sm-notification_red_bell';
      } else {
        className = 'sp-ic-sm-notification_bell';
      }
      document.getElementById('notifcation_bell').classList = className;
    },
    handleMouseOutNotificationIcon() {
      const className = this.getNotificationIconClass();
      document.getElementById('notifcation_bell').classList = className;
    },
    toggleNotificationBoard() {
      if (!this.isShowingNotificationBoard) {
        this.setNotificationViewedAPI();
      }
      this.$store.dispatch('notifications/toggleNotificationBoard', !this.isShowingNotificationBoard);
    },
    clickOutsideNotificationBoard() {
      this.$store.dispatch('notifications/toggleNotificationBoard', false);
    },
    initScroll() {
      window.addEventListener('scroll', (event) => {
        const offset = window.pageYOffset || document.documentElement.scrollTop;
        const windowWidth = window.innerWidth;

        if (windowWidth <= 770) {
          if (offset < 50) {
            this.headerStyle = '';
          } else {
            this.headerStyle = 'background-color: rgba(31,33,46,0.9);';
          }
        } else {
          if (offset > 50) {
            this.headerStyle = 'background-color: rgba(31,33,46,0.9);';
          } else {
            this.headerStyle = '';
          }
        }
        this.previousTop = offset;
      });
    },
    initDeviceChangeThemeEventListener() {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
        const newColorScheme = event.matches ? 'dark' : 'light';
        const themeStatus = newColorScheme === 'dark' ? 0 : 1;
        if (this.isAuth) {
          EventBus.$emit(HANDLE_CHANGE_THEME_SETTING, themeStatus);
        } else {
          if (this.isMobile()) {
            localStorage.setItem('theme', newColorScheme);
            document.documentElement.setAttribute('data-theme', newColorScheme);
          }
        }
      });
    },
    redirectToDropsPage() {
      localStorage.setItem('view_drops', 'true');
      window.location.href = this.routeDropsPage();
    },
    checkShowDropsHighlight() {
      if (localStorage.getItem('view_drops') === 'false') {
        this.setShowDropsHighlight(true);
      } else {
        this.setShowDropsHighlight(false);
      }
    },
    async checkAndShowHubOnboarding(isAboutHub = 0) {
      // if (!this.isAuth) {
      //   EventBus.$emit(SHOW_MODAL_ONBOARDING_HUB, 1);
      // } else {
      //   const res = await this.getHubInfoApi(this.userData.id);
      //   if (res.status === 0) {
      //     const urlRedirect = res.url_redirect;
      //     if (isAboutHub) {
      //       EventBus.$emit(SHOW_MODAL_ONBOARDING_HUB, 3);
      //     } else {
      //       window.location.href = urlRedirect;
      //     }
      //   } else {
      //     const friendsNeed = res.friends_need;
      //     EventBus.$emit(SHOW_MODAL_ONBOARDING_HUB, 2, friendsNeed > 0 ? friendsNeed : '');
      //   }
      // }
    },
    showModalSelectManageHub() {
      if (this.userHubData.hub_admin === 1) {
        window.location.href = this.appConfig.baseUrl + '/' + this.userHubData.hub_alias + '/admin';
      } else {
        EventBus.$emit(SHOW_MODAL_SELECT_MANAGE_HUB);
      }
    },
    redirectToHubPage(url) {
      window.location.href = url;
    },
    toggleLogoMenu() {
      this.showLogoDropdownMenu = !this.showLogoDropdownMenu;
      EventBus.$emit(TOGGLE_TOP_MENU_LOGO, this.showLogoDropdownMenu, 2);
      if (this.isMobile()) {
        EventBus.$emit(TOGGLE_DROPDOWN_PROFILE_TOP_HEADER, false);
      }
    },
    clickOutsideLogoMenu() {
      this.showLogoDropdownMenu = false;
      EventBus.$emit(TOGGLE_TOP_MENU_LOGO, this.showLogoDropdownMenu, 1);
    },
    handleClickProfileDropdown() {
      if (this.isMobile()) {
        this.toggleProfileDropdown();
      } else {
        location.href = this.routeMyProfile();
      }
    },
    toggleProfileDropdown() {
      if (this.checkMobileDevice) {
        EventBus.$emit(TOGGLE_DROPDOWN_PROFILE_TOP_HEADER);
      }
      return;
    },
    showProfileDropdown() {
      if (!this.isMobile()) {
        EventBus.$emit(TOGGLE_DROPDOWN_PROFILE_TOP_HEADER, true);
      }
    },
    hideProfileDropdown() {
      if (!this.isMobile()) {
        EventBus.$emit(TOGGLE_DROPDOWN_PROFILE_TOP_HEADER, false);
      }
    },
  },
};
</script>
